// extracted by mini-css-extract-plugin
module.exports = {"map":"_1bCtQ","map-section":"_1vS2y","sl-wrap":"_323QY"};